/* tslint:disable */
/* eslint-disable */
/**
 * Assemblean Production Solutions
 * Produce the lean way with APCS
 *
 * The version of the OpenAPI document: 0.9.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  APIBOM,
  APIBOMRequest,
  APIPaginatedBOMList,
  APIPatchedBOMRequest,
} from '../models/index';
import {
    APIBOMFromJSON,
    APIBOMToJSON,
    APIBOMRequestFromJSON,
    APIBOMRequestToJSON,
    APIPaginatedBOMListFromJSON,
    APIPaginatedBOMListToJSON,
    APIPatchedBOMRequestFromJSON,
    APIPatchedBOMRequestToJSON,
} from '../models/index';

export interface V1ItemsArticlesBomBatchDeleteDestroyRequest {
    articlePk: string;
}

export interface V1ItemsArticlesBomCreateRequest {
    articlePk: string;
    aPIBOMRequest: APIBOMRequest;
}

export interface V1ItemsArticlesBomDestroyRequest {
    articlePk: string;
    id: number;
}

export interface V1ItemsArticlesBomListRequest {
    articlePk: string;
    page?: number;
    pageSize?: number;
}

export interface V1ItemsArticlesBomPartialUpdateRequest {
    articlePk: string;
    id: number;
    aPIPatchedBOMRequest?: APIPatchedBOMRequest;
}

export interface V1ItemsArticlesBomRetrieveRequest {
    articlePk: string;
    id: number;
}

export interface V1ItemsArticlesBomUpdateRequest {
    articlePk: string;
    id: number;
    aPIBOMRequest: APIBOMRequest;
}

export interface V1ItemsBomsCreateRequest {
    aPIBOMRequest: APIBOMRequest;
}

export interface V1ItemsBomsDestroyRequest {
    id: number;
}

export interface V1ItemsBomsListRequest {
    page?: number;
    pageSize?: number;
}

export interface V1ItemsBomsPartialUpdateRequest {
    id: number;
    aPIPatchedBOMRequest?: APIPatchedBOMRequest;
}

export interface V1ItemsBomsRetrieveRequest {
    id: number;
}

export interface V1ItemsBomsUpdateRequest {
    id: number;
    aPIBOMRequest: APIBOMRequest;
}

/**
 * 
 */
export class ItemsbomApi extends runtime.BaseAPI {

    /**
     * Mixin to provide support for Serializer Extensions within API views.
     */
    async v1ItemsArticlesBomBatchDeleteDestroyRaw(requestParameters: V1ItemsArticlesBomBatchDeleteDestroyRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['articlePk'] == null) {
            throw new runtime.RequiredError(
                'articlePk',
                'Required parameter "articlePk" was null or undefined when calling v1ItemsArticlesBomBatchDeleteDestroy().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("jwtAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/items/articles/{article_pk}/bom/batch_delete/`.replace(`{${"article_pk"}}`, encodeURIComponent(String(requestParameters['articlePk']))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Mixin to provide support for Serializer Extensions within API views.
     */
    async v1ItemsArticlesBomBatchDeleteDestroy(requestParameters: V1ItemsArticlesBomBatchDeleteDestroyRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.v1ItemsArticlesBomBatchDeleteDestroyRaw(requestParameters, initOverrides);
    }

    /**
     * Mixin to provide support for Serializer Extensions within API views.
     */
    async v1ItemsArticlesBomCreateRaw(requestParameters: V1ItemsArticlesBomCreateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<APIBOM>> {
        if (requestParameters['articlePk'] == null) {
            throw new runtime.RequiredError(
                'articlePk',
                'Required parameter "articlePk" was null or undefined when calling v1ItemsArticlesBomCreate().'
            );
        }

        if (requestParameters['aPIBOMRequest'] == null) {
            throw new runtime.RequiredError(
                'aPIBOMRequest',
                'Required parameter "aPIBOMRequest" was null or undefined when calling v1ItemsArticlesBomCreate().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("jwtAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/items/articles/{article_pk}/bom/`.replace(`{${"article_pk"}}`, encodeURIComponent(String(requestParameters['articlePk']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: APIBOMRequestToJSON(requestParameters['aPIBOMRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => APIBOMFromJSON(jsonValue));
    }

    /**
     * Mixin to provide support for Serializer Extensions within API views.
     */
    async v1ItemsArticlesBomCreate(requestParameters: V1ItemsArticlesBomCreateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<APIBOM> {
        const response = await this.v1ItemsArticlesBomCreateRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Mixin to provide support for Serializer Extensions within API views.
     */
    async v1ItemsArticlesBomDestroyRaw(requestParameters: V1ItemsArticlesBomDestroyRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['articlePk'] == null) {
            throw new runtime.RequiredError(
                'articlePk',
                'Required parameter "articlePk" was null or undefined when calling v1ItemsArticlesBomDestroy().'
            );
        }

        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling v1ItemsArticlesBomDestroy().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("jwtAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/items/articles/{article_pk}/bom/{id}/`.replace(`{${"article_pk"}}`, encodeURIComponent(String(requestParameters['articlePk']))).replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Mixin to provide support for Serializer Extensions within API views.
     */
    async v1ItemsArticlesBomDestroy(requestParameters: V1ItemsArticlesBomDestroyRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.v1ItemsArticlesBomDestroyRaw(requestParameters, initOverrides);
    }

    /**
     * Mixin to provide support for Serializer Extensions within API views.
     */
    async v1ItemsArticlesBomListRaw(requestParameters: V1ItemsArticlesBomListRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<APIPaginatedBOMList>> {
        if (requestParameters['articlePk'] == null) {
            throw new runtime.RequiredError(
                'articlePk',
                'Required parameter "articlePk" was null or undefined when calling v1ItemsArticlesBomList().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['page'] != null) {
            queryParameters['page'] = requestParameters['page'];
        }

        if (requestParameters['pageSize'] != null) {
            queryParameters['page_size'] = requestParameters['pageSize'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("jwtAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/items/articles/{article_pk}/bom/`.replace(`{${"article_pk"}}`, encodeURIComponent(String(requestParameters['articlePk']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => APIPaginatedBOMListFromJSON(jsonValue));
    }

    /**
     * Mixin to provide support for Serializer Extensions within API views.
     */
    async v1ItemsArticlesBomList(requestParameters: V1ItemsArticlesBomListRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<APIPaginatedBOMList> {
        const response = await this.v1ItemsArticlesBomListRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Mixin to provide support for Serializer Extensions within API views.
     */
    async v1ItemsArticlesBomPartialUpdateRaw(requestParameters: V1ItemsArticlesBomPartialUpdateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<APIBOM>> {
        if (requestParameters['articlePk'] == null) {
            throw new runtime.RequiredError(
                'articlePk',
                'Required parameter "articlePk" was null or undefined when calling v1ItemsArticlesBomPartialUpdate().'
            );
        }

        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling v1ItemsArticlesBomPartialUpdate().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("jwtAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/items/articles/{article_pk}/bom/{id}/`.replace(`{${"article_pk"}}`, encodeURIComponent(String(requestParameters['articlePk']))).replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'PATCH',
            headers: headerParameters,
            query: queryParameters,
            body: APIPatchedBOMRequestToJSON(requestParameters['aPIPatchedBOMRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => APIBOMFromJSON(jsonValue));
    }

    /**
     * Mixin to provide support for Serializer Extensions within API views.
     */
    async v1ItemsArticlesBomPartialUpdate(requestParameters: V1ItemsArticlesBomPartialUpdateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<APIBOM> {
        const response = await this.v1ItemsArticlesBomPartialUpdateRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Mixin to provide support for Serializer Extensions within API views.
     */
    async v1ItemsArticlesBomRetrieveRaw(requestParameters: V1ItemsArticlesBomRetrieveRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<APIBOM>> {
        if (requestParameters['articlePk'] == null) {
            throw new runtime.RequiredError(
                'articlePk',
                'Required parameter "articlePk" was null or undefined when calling v1ItemsArticlesBomRetrieve().'
            );
        }

        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling v1ItemsArticlesBomRetrieve().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("jwtAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/items/articles/{article_pk}/bom/{id}/`.replace(`{${"article_pk"}}`, encodeURIComponent(String(requestParameters['articlePk']))).replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => APIBOMFromJSON(jsonValue));
    }

    /**
     * Mixin to provide support for Serializer Extensions within API views.
     */
    async v1ItemsArticlesBomRetrieve(requestParameters: V1ItemsArticlesBomRetrieveRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<APIBOM> {
        const response = await this.v1ItemsArticlesBomRetrieveRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Mixin to provide support for Serializer Extensions within API views.
     */
    async v1ItemsArticlesBomUpdateRaw(requestParameters: V1ItemsArticlesBomUpdateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<APIBOM>> {
        if (requestParameters['articlePk'] == null) {
            throw new runtime.RequiredError(
                'articlePk',
                'Required parameter "articlePk" was null or undefined when calling v1ItemsArticlesBomUpdate().'
            );
        }

        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling v1ItemsArticlesBomUpdate().'
            );
        }

        if (requestParameters['aPIBOMRequest'] == null) {
            throw new runtime.RequiredError(
                'aPIBOMRequest',
                'Required parameter "aPIBOMRequest" was null or undefined when calling v1ItemsArticlesBomUpdate().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("jwtAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/items/articles/{article_pk}/bom/{id}/`.replace(`{${"article_pk"}}`, encodeURIComponent(String(requestParameters['articlePk']))).replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: APIBOMRequestToJSON(requestParameters['aPIBOMRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => APIBOMFromJSON(jsonValue));
    }

    /**
     * Mixin to provide support for Serializer Extensions within API views.
     */
    async v1ItemsArticlesBomUpdate(requestParameters: V1ItemsArticlesBomUpdateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<APIBOM> {
        const response = await this.v1ItemsArticlesBomUpdateRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Mixin to provide support for Serializer Extensions within API views.
     */
    async v1ItemsBomsBatchDeleteDestroyRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("jwtAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/items/boms/batch_delete/`,
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Mixin to provide support for Serializer Extensions within API views.
     */
    async v1ItemsBomsBatchDeleteDestroy(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.v1ItemsBomsBatchDeleteDestroyRaw(initOverrides);
    }

    /**
     * Mixin to provide support for Serializer Extensions within API views.
     */
    async v1ItemsBomsCreateRaw(requestParameters: V1ItemsBomsCreateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<APIBOM>> {
        if (requestParameters['aPIBOMRequest'] == null) {
            throw new runtime.RequiredError(
                'aPIBOMRequest',
                'Required parameter "aPIBOMRequest" was null or undefined when calling v1ItemsBomsCreate().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("jwtAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/items/boms/`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: APIBOMRequestToJSON(requestParameters['aPIBOMRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => APIBOMFromJSON(jsonValue));
    }

    /**
     * Mixin to provide support for Serializer Extensions within API views.
     */
    async v1ItemsBomsCreate(requestParameters: V1ItemsBomsCreateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<APIBOM> {
        const response = await this.v1ItemsBomsCreateRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Mixin to provide support for Serializer Extensions within API views.
     */
    async v1ItemsBomsDestroyRaw(requestParameters: V1ItemsBomsDestroyRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling v1ItemsBomsDestroy().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("jwtAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/items/boms/{id}/`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Mixin to provide support for Serializer Extensions within API views.
     */
    async v1ItemsBomsDestroy(requestParameters: V1ItemsBomsDestroyRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.v1ItemsBomsDestroyRaw(requestParameters, initOverrides);
    }

    /**
     * Mixin to provide support for Serializer Extensions within API views.
     */
    async v1ItemsBomsListRaw(requestParameters: V1ItemsBomsListRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<APIPaginatedBOMList>> {
        const queryParameters: any = {};

        if (requestParameters['page'] != null) {
            queryParameters['page'] = requestParameters['page'];
        }

        if (requestParameters['pageSize'] != null) {
            queryParameters['page_size'] = requestParameters['pageSize'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("jwtAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/items/boms/`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => APIPaginatedBOMListFromJSON(jsonValue));
    }

    /**
     * Mixin to provide support for Serializer Extensions within API views.
     */
    async v1ItemsBomsList(requestParameters: V1ItemsBomsListRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<APIPaginatedBOMList> {
        const response = await this.v1ItemsBomsListRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Mixin to provide support for Serializer Extensions within API views.
     */
    async v1ItemsBomsPartialUpdateRaw(requestParameters: V1ItemsBomsPartialUpdateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<APIBOM>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling v1ItemsBomsPartialUpdate().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("jwtAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/items/boms/{id}/`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'PATCH',
            headers: headerParameters,
            query: queryParameters,
            body: APIPatchedBOMRequestToJSON(requestParameters['aPIPatchedBOMRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => APIBOMFromJSON(jsonValue));
    }

    /**
     * Mixin to provide support for Serializer Extensions within API views.
     */
    async v1ItemsBomsPartialUpdate(requestParameters: V1ItemsBomsPartialUpdateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<APIBOM> {
        const response = await this.v1ItemsBomsPartialUpdateRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Mixin to provide support for Serializer Extensions within API views.
     */
    async v1ItemsBomsRetrieveRaw(requestParameters: V1ItemsBomsRetrieveRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<APIBOM>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling v1ItemsBomsRetrieve().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("jwtAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/items/boms/{id}/`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => APIBOMFromJSON(jsonValue));
    }

    /**
     * Mixin to provide support for Serializer Extensions within API views.
     */
    async v1ItemsBomsRetrieve(requestParameters: V1ItemsBomsRetrieveRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<APIBOM> {
        const response = await this.v1ItemsBomsRetrieveRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Mixin to provide support for Serializer Extensions within API views.
     */
    async v1ItemsBomsUpdateRaw(requestParameters: V1ItemsBomsUpdateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<APIBOM>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling v1ItemsBomsUpdate().'
            );
        }

        if (requestParameters['aPIBOMRequest'] == null) {
            throw new runtime.RequiredError(
                'aPIBOMRequest',
                'Required parameter "aPIBOMRequest" was null or undefined when calling v1ItemsBomsUpdate().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("jwtAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/items/boms/{id}/`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: APIBOMRequestToJSON(requestParameters['aPIBOMRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => APIBOMFromJSON(jsonValue));
    }

    /**
     * Mixin to provide support for Serializer Extensions within API views.
     */
    async v1ItemsBomsUpdate(requestParameters: V1ItemsBomsUpdateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<APIBOM> {
        const response = await this.v1ItemsBomsUpdateRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
